export default `<g fill="none"
stroke="currentColor"
stroke-width="2"
stroke-linecap="round"
stroke-linejoin="round"><path d="M21.92,11.54h-9.54V2h-0.84v9.54H2v0.84h9.54v9.55h0.84v-9.55h9.54V11.54z"/></g>`;
